import { toast } from 'react-toastify';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';
import { Button, TextField, InputAdornment, Select, MenuItem, InputLabel, FormControl } from '@material-ui/core';
import Swal from 'sweetalert2'

import Prompt from '../../../Shared/Prompt/Prompt';
import PromptWrapper from '../../../Shared/Prompt/Wrapper';
import PromptActions from '../../../Shared/Prompt/Actions';

import { colors, toastTimerValue } from '../../../../Shared/utils';
import { get, update } from '../../../../Functions/admin';

import { decodeHTMLEntities } from '../../../../Functions/utils';



import '../../../SweetAlert.css'

export default function SingleGroup() {
  const { t } = useTranslation();
  const [group, setGroup] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newGroup, setNewGroup] = useState(null);


  const handleEdit = (e, group) => {
    e.preventDefault();
    setLoading(true);

    update({type: 'group', group}).then(res => {
      setLoading(false);

      if (!res.success) {
        toast(decodeHTMLEntities(t('admin.groups.errors.' + res, {name: group.name})), {type: 'error'});

        // Swal.fire({
        //   toast: true,
        //   icon: 'error',
        //   title: t('admin.groups.errors.' + res, {name: group.name}),
        //   animation: true,
        //   position: 'top-right',
        //   showConfirmButton: false,
        //   timer: toastTimerValue,
        //   timerProgressBar: true,
        //   iconColor: 'white',
        //   customClass: {
        //     popup: 'colored-toast',
        //   },
        //   didOpen: (toast) => {
        //     toast.addEventListener('mouseenter', Swal.stopTimer)
        //     toast.addEventListener('mouseleave', Swal.resumeTimer)
        //     toast.addEventListener('click', Swal.close)
        //   }
        // });
      }
      else {
        setGroup(res.group);
        toast(decodeHTMLEntities(t('admin.groups.update.success', {name: group.name})), {type: 'success'});

        // Swal.fire({
        //   toast: true,
        //   icon: 'success',
        //   title: t('admin.groups.update.success', {name: group.name}),
        //   animation: true,
        //   position: 'top-right',
        //   showConfirmButton: false,
        //   timer: toastTimerValue,
        //   timerProgressBar: true,
        //   iconColor: 'white',
        //   customClass: {
        //     popup: 'colored-toast',
        //   },
        //   didOpen: (toast) => {
        //     toast.addEventListener('mouseenter', Swal.stopTimer)
        //     toast.addEventListener('mouseleave', Swal.resumeTimer)
        //     toast.addEventListener('click', Swal.close)
        //   }
        // });
      }
    });
  };


  useEffect(() => {
    document.title = t('admin.groups.page_single');
    window.history.pushState('', document.title, '/admin/group');

    if (!group) get({type: 'group'}).then(res => {
      setLoading(false);

      if (!res.success) {
        return toast(decodeHTMLEntities(t('admin.groups.errors.' + res + '_single')), {type: 'error'});

        // return Swal.fire({
        //   toast: true,
        //   icon: 'error',
        //   title: t('admin.groups.errors.' + res + '_single'),
        //   animation: true,
        //   position: 'top-right',
        //   showConfirmButton: false,
        //   timer: toastTimerValue,
        //   timerProgressBar: true,
        //   iconColor: 'white',
        //   customClass: {
        //     popup: 'colored-toast',
        //   },
        //   didOpen: (toast) => {
        //     toast.addEventListener('mouseenter', Swal.stopTimer)
        //     toast.addEventListener('mouseleave', Swal.resumeTimer)
        //     toast.addEventListener('click', Swal.close)
        //   }
        // });
      }

      setGroup(res.groups[0]);
      setNewGroup(res.groups[0]);
    });
  }, [t, group]);


  return (
    <div className="admin group">
      <Prompt>
        <form className="prompt__container" onSubmit={e => handleEdit(e, newGroup)}>
          {(group && newGroup) ? (
            <>
              <PromptWrapper>
                <div className="prompt__title">
                  <h1>{t('admin.groups.update.title', {name: group.name})}</h1>
                  <div style={{textAlign: 'unset', width: '50%', margin: '20px auto 0'}}>
                    <FormControl variant="outlined" style={{width: '100%'}}>
                      <InputLabel>{t('admin.groups.columns.management')}</InputLabel>
                      <Select
                        value={newGroup.management}
                        label={t('admin.groups.columns.management')}
                        onChange={e => {
                          const management = e.target.value;
                          const pageSize = management === 'US' ? 'LETTER' : 'A4';
                          setNewGroup({...newGroup, management, pageSize});
                        }}
                      >
                        <MenuItem value="France">France</MenuItem>
                        <MenuItem value="US">US</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>

                <div className="prompt__content">
                  <TextField
                    InputProps={{
                      startAdornment: <InputAdornment position="start">
                        <span className="material-icons-outlined">description</span>
                      </InputAdornment>
                    }}
                    variant="outlined"
                    value={newGroup.name}
                    inputProps={{maxLength: 50}}
                    label={t('admin.groups.columns.name')}
                    onChange={e => setNewGroup({...newGroup, name: e.target.value})}
                  />
                </div>
              </PromptWrapper>

              <PromptActions>
                <Button
                  className="btnSecondary"
                  disabled={group === newGroup}
                  onClick={() => setNewGroup(group)}
                >{t('global.cancel')}</Button>

                <Button type="submit" className="btnPrimary">
                  {loading ? <BeatLoader color="white" css="transform:translateY(4px)"/> : t('global.save')}
                </Button>
              </PromptActions>
            </>
          ) : (
            <div className="loader">
              <BeatLoader color={colors.softthinks}/>
            </div>
          )}
        </form>
      </Prompt>
    </div>
  );
}
